var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource"},[_c('p',[_c('span',{staticClass:"resource_label"},[_vm._v(_vm._s(_vm.resource.label))]),_c('span',{staticClass:"resource_box",on:{"click":function($event){return _vm.increment(_vm.resource_id)}}},[_c('span',{staticClass:"resource_bar",style:(_vm.barStyle)})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }